import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

// Requires: npm install socket.io-client --save (in frontend/)
//
// Usage in ChatPage.jsx (replaces the polling interval):
//   const socket = useSocket();
//   useEffect(() => {
//     if (!socket || !active) return;
//     socket.emit('join_group', active.id);
//     socket.on('new_message', (msg) => setMessages(prev => [...prev, msg]));
//     return () => { socket.emit('leave_group', active.id); socket.off('new_message'); };
//   }, [socket, active?.id]);

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

export function useSocket() {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('tms_token');
    if (!token) return;

    const s = io(SOCKET_URL, { auth: { token } });
    socketRef.current = s;
    setSocket(s);

    return () => { s.disconnect(); };
  }, []);

  return socket;
}

export function useTypingIndicator(socket, groupId) {
  const [typingUsers, setTypingUsers] = useState([]);

  useEffect(() => {
    if (!socket) return;
    const onTyping = (data) => {
      if (data.groupId !== groupId) return;
      setTypingUsers(prev => prev.some(u=>u.userId===data.userId) ? prev : [...prev, data]);
    };
    const onStopped = (data) => {
      if (data.groupId !== groupId) return;
      setTypingUsers(prev => prev.filter(u => u.userId !== data.userId));
    };
    socket.on('user_typing', onTyping);
    socket.on('user_stopped_typing', onStopped);
    return () => { socket.off('user_typing', onTyping); socket.off('user_stopped_typing', onStopped); };
  }, [socket, groupId]);

  return typingUsers;
}
